export enum WiseRecipientFormFieldTypesEnum {
  select = 'select',
  text = 'text',
  radio = 'radio',
  date = 'date',
}
